<template>
  <div>
    <div id="content">
      <div class="menu-bar">
        <a class="btn link-green" @click="getDevirs()">
          <i class="fa fa fa-sync"></i>
          Devir Notunu Yenile
        </a>

        <select class="small-select" v-model="printBirim">
          <option value="1">Yenidoğan</option>
          <option value="2">Yoğun Bakım</option>
        </select>

        <a class="btn btn-blue" v-show="devir.yd.length" @click="printDevir()">
          <i class="fa fa fa-print"></i>
          Yazdır
        </a>
      </div>
      <DevirModalYD
        v-if="editingDevir"
        :selectedPatient="selectedPatient"
        path="yogunbakim/"
        @close="closeDevir()"
        @save="saveDevir()"
      ></DevirModalYD>
      <DevirModalYB
        v-if="editingDevirYB"
        :selectedPatient="selectedPatient"
        path="servis/y/"
        @close="closeDevir()"
        @save="saveDevirYB()"
      ></DevirModalYB>
      <div class="rop-list" v-show="printBirim == 1">
        <div class="title">İlk ROP Muayene Tarihleri</div>
        <ul class="list">
          <li v-for="d in rop_patients" :key="d.id">
            <span class="name">{{ d.name }}</span>
            <span class="date">
              {{ d.rop_date | moment("DD MMMM YYYY") }}
            </span>
            <span class="from">
              {{ d.rop_date | moment("from") }}
            </span>
          </li>
        </ul>
      </div>
      <div class="p-devir">
        <div class="large-empty" v-if="!devir.yd.length">
          <i class="fa fa-info-circle fa-3x"></i>
          <span>Yenidoğan Yoğun Bakımda Yatan Hasta Yok</span>
        </div>
        <div id="pra-devir" class="page">
          <div class="b-tarih" v-if="devir.yd.length">
            {{ new Date() | moment("DD MMMM YYYY HH:mm") }}
          </div>
          <draggable
            tag="el-collapse"
            v-model="patients"
            v-bind="dragOptions"
            v-show="printBirim == 1"
            @start="onStart()"
            @end="onEnd()"
          >
            <transition-group type="transition" name="flip-list">
              <div
                v-for="(d, i) in patients"
                :key="d.id"
                class="hasta card-click"
                @click="user.level == 1 ? editDevir(d.id) : ''"
              >
                <div class="top-devir">
                  <div class="no">{{ i + 1 }}</div>
                  <div class="name">
                    <span>
                      <b>{{ d.name }}</b>
                    </span>
                    <span class="details">
                      {{ d.sex | toSex }}, {{ gh(d) }},
                      {{ d.birth | toYDGun }}
                    </span>
                  </div>
                  <div class="oda">{{ takip(d) }}</div>
                </div>
                <transition-group name="fadeHeight">
                  <p :key="d.id" v-show="!dragging">
                    <b>{{ d.tanilar }}</b>
                    <br />
                    YATIŞININ
                    <b>{{ d.yatis | toGun }}Ü</b>
                    , D.YAŞI :
                    <b>
                      {{ dyas(d.birthdate, d.dhafta, d.dgun) }}
                    </b>
                    , D.TARTISI :
                    <b>{{ d.dtarti }}</b>
                    GR
                    <br />
                    {{ solunumlar(d.takip_solunum) }}
                    <br />
                    {{ d.takip_beslenme }}
                    <br />
                    <span v-html="tedaviler(d.tedavi)"></span>
                  </p>
                  <p :key="d.id + 1" v-show="!dragging">
                    <b>{{ d.plan2 }}</b>
                    <br />
                    <b>{{ d.plan }}</b>
                  </p>
                </transition-group>
              </div>
            </transition-group>
          </draggable>
          <div
            v-show="printBirim == 2"
            v-for="(d, i) in yb_patients"
            :key="d.id"
            class="hasta card-click"
            @click="user.level == 1 ? editDevirYB(d.id) : ''"
          >
            <div class="top-devir">
              <div class="no">{{ i + 1 }}</div>
              <div class="name">
                <span>
                  <b>{{ d.name }}</b>
                </span>
                <span class="details">
                  {{ d.sex | toSex }}, {{ d.birth | toYas }}, {{ d.kg }} KG ({{
                    d.kilop
                  }})
                </span>
              </div>
              <div class="oda">{{ servis(d.yeri) }} - {{ d.oda }}</div>
            </div>
            <p>
              TANI :
              <b>{{ d.tanilar }}</b>
            </p>
            <p>
              YATIŞ :
              <b>{{ d.yatis | toGun }}</b>
            </p>
            <p>
              <b>ALDIĞI TEDAVİLER</b>
            </p>
            <ul>
              <li v-for="t in d.tedavi" :key="t.id">
                {{ t.tedavi }}
                {{ t.doz != "" ? "(" + t.doz + ")" : "" }}
                <b>{{ (t.gun == 1 ? t.tarih : "") | toGun }}</b>
              </li>
            </ul>
            <p>
              {{ d.devir }}
            </p>
            <p>
              <u><b>TAKİPLER VE PLAN</b></u>
            </p>
            <p>
              <b>{{ d.plan }}</b>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import draggable from "vuedraggable";
import DevirModalYD from "../components/DevirModalYenidogan.vue";
import DevirModalYB from "../components/DevirModalServis.vue";
export default {
  name: "DevirYD",
  components: {
    draggable,
    DevirModalYD,
    DevirModalYB,
  },
  data() {
    return {
      dragging: false,
      editingDevir: false,
      editingDevirYB: false,
      khd: [],
      selectedPatient: [],
      printBirim: 1,
      tedavi: {
        mode: 0,
        veri: {},
      },
    };
  },
  computed: {
    devir() {
      return this.$store.getters.getPatients;
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost-patient",
        delay: 1000, // time in milliseconds to define when the sorting should start
        delayOnTouchOnly: true,
      };
    },
    patients: {
      get() {
        return this.devir.yd;
      },
      set(value) {
        var sirali = value;
        var i = 0;
        sirali.forEach((sirali) => {
          sirali.kuvoz = i;
          i = i + 1;
        });
        var veri = JSON.parse(JSON.stringify(this.devir.yd));
        this.$http({
          method: "post",
          url: "api/yenidogan/sirala.php",
          data: qs.stringify(veri),
        }).then(() => {
          this.$snotify.success("Hasta sıralaması güncellendi");
          this.$socket.client.emit("update", "patients");
          this.getDevirs();
        });
      },
    },
    rop_patients() {
      return this.devir.rop;
    },
    yb_patients() {
      return this.devir.yb;
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    servis(id) {
      return this.$store.getters.getServisKisa(id);
    },
    onStart() {
      setTimeout(() => {
        this.dragging = true;
      }, 300);
    },
    onEnd() {
      setTimeout(() => {
        this.dragging = false;
      }, 800);
    },
    gunFarkiDay(b1, b2) {
      var days = this.$moment(b2).diff(this.$moment(b1), "days", true);
      return Math.ceil(days);
    },
    dyas(b, hafta, gun) {
      var r = this.gunFarkiDay(b, new Date()) - 1;
      var h = Math.floor(r / 7);
      var g = parseInt(gun);
      var dh, dg;

      if (r - h * 7 + g < 7) {
        dh = parseInt(hafta) + h;
        dg = r - h * 7 + g;
      } else {
        dh = parseInt(hafta) + h + 1;
        dg = r - h * 7 + g - 7;
      }
      return dh + "w" + (dg > 0 ? "+" + dg + "d" : "");
    },
    gh(p) {
      return p.dhafta + "w" + (p.dgun > 0 ? "+" + p.dgun + "d" : "");
    },
    takip(p) {
      var sonuc = "";
      if (p.ks > 0) {
        sonuc += "KŞ*" + p.ks + " ";
      }
      if (p.tcb > 0) {
        sonuc += "TCB*" + p.tcb + " ";
      }
      if (p.tarti > 1) {
        sonuc += "TARTI*" + p.tarti;
      }
      return sonuc;
    },
    tedaviler(t) {
      var tedaviler = "";
      var guntedaviler = "";
      let self = this;
      t.forEach(function(arrayItem) {
        if (arrayItem.gun == 1) {
          var abgun = self.gunFarki(arrayItem.tarih, new Date());
          guntedaviler +=
            arrayItem.tedavi +
            (arrayItem.doz == "" ? " " : " (" + arrayItem.doz + ") ") +
            "<b>" +
            abgun +
            "ÜNDE</b> ";
        } else {
          tedaviler +=
            arrayItem.tedavi +
            (arrayItem.doz == "" ? "" : " " + arrayItem.doz) +
            " ALIYOR." +
            "\n";
        }
      });
      return guntedaviler + (guntedaviler == "" ? "" : "\n") + tedaviler;
    },
    solunumlar(d) {
      var r;
      switch (d) {
        case "1":
          r = "K.İÇİ ODA HAVASINDA TAKİPLİ";
          break;
        case "2":
          r = "K.İÇİ SERBEST O2 ALIYOR";
          break;
        case "3":
          r = "K.İÇİ NCPAP'TA TAKİPLİ";
          break;
        case "4":
          r = "K.İÇİ ENTÜBE TAKİPLİ";
          break;
      }
      return r;
    },
    editDevir(id) {
      this.editingDevir = true;
      this.selectedPatient = this.devir.yd.find((t) => t.id === id);
    },
    editDevirYB(id) {
      this.editingDevirYB = true;
      this.selectedPatient = this.devir.yb.find((t) => t.id === id);
    },
    closeDevir() {
      this.editingDevir = false;
      this.editingDevirYB = false;
      this.selectedPatient = [];
    },
    saveDevir() {
      var veri = JSON.parse(JSON.stringify(this.selectedPatient));
      veri.q = "devir";
      this.$http({
        method: "post",
        url: "api/yenidogan/edit-patient.php",
        data: qs.stringify(veri),
      }).then(() => {
        this.$snotify.success("Devir notu başarıyla güncellendi");
        this.$socket.client.emit("update", "patients");
        this.editingDevir = false;
        this.getDevirs();
      });
    },
    saveDevirYB() {
      var veri = JSON.parse(JSON.stringify(this.selectedPatient));
      veri.q = "devir";
      this.$http({
        method: "post",
        url: "api/edit-patient.php",
        data: qs.stringify(veri),
      }).then(() => {
        this.$snotify.success("Devir notu başarıyla güncellendi");
        this.$socket.client.emit("update", "patients");
        this.editingDevirYB = false;
        this.getDevirs();
      });
    },

    gunFarki(b1, b2) {
      var days = this.$moment(b2).diff(this.$moment(b1), "days", true);
      return Math.ceil(days) + ".GÜN";
    },
    printDevir() {
      const options = {
        name: "_blank",
        specs: ["height=800", "height=800", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://pediatrim.net/print/devirYD.css"],
      };
      this.$htmlToPaper("pra-devir", options);
    },
    getDevirs() {
      this.$store.dispatch("fillPatients");
    },
  },
};
</script>

<style lang="scss">
el-collapse {
  width: 100%;
  p {
    line-height: 22px;
  }
}
.small-select {
  padding: 0 !important;
}
</style>
